import styled from 'astroturf/react'
const spacing1x = 'var(--spacing-1x, 1rem)'

import Fieldset from 'components/form/fieldset'
import _EnterDetailsFieldStack from "form_field_spacing-EnterDetailsFieldStack.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/form_field_spacing.js?styleId=EnterDetailsFieldStack";
import _EnterDetailsFieldset from "form_field_spacing-EnterDetailsFieldset.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/form_field_spacing.js?styleId=EnterDetailsFieldset";
import _EnterDetailsFieldStackNested from "form_field_spacing-EnterDetailsFieldStackNested.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/form_field_spacing.js?styleId=EnterDetailsFieldStackNested";


const fieldStackStyles = `
  display: flex;
  flex-direction: column;
  gap: var(--enter-details-field-gap, 20px);
`

/** Vertical stack for enter-details field sections; sets gap token for nested stacks. */
export const EnterDetailsFieldStack = /*#__PURE__*/styled('div', null, {
  displayName: "EnterDetailsFieldStack",
  styles: _EnterDetailsFieldStack,
  attrs: props => ({
    ...props,
    'data-enter-details-field-stack': true
  })
})

/** Fieldset variant; inherits --enter-details-field-gap from an ancestor stack. */
export const EnterDetailsFieldset = /*#__PURE__*/styled(Fieldset, null, {
  displayName: "EnterDetailsFieldset",
  styles: _EnterDetailsFieldset
})

/** Nested stack (e.g. payment blocks); inherits gap from ancestor EnterDetailsFieldStack. */
export const EnterDetailsFieldStackNested = /*#__PURE__*/styled('div', null, {
  displayName: "EnterDetailsFieldStackNested",
  styles: _EnterDetailsFieldStackNested
})
